var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearNodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14852_21047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.73438 15.888C5.93169 16.0853 6.16594 16.2418 6.42376 16.3486C6.68157 16.4554 6.95789 16.5104 7.23695 16.5104H9.25521C9.81881 16.5104 10.3593 16.2865 10.7578 15.888L18.0131 8.63277C18.4115 8.23425 18.6354 7.69375 18.6354 7.13017C18.6354 6.56659 18.4115 6.02609 18.0131 5.62757L15.0078 2.62236C14.6093 2.22387 14.0688 2 13.5052 2C12.9417 2 12.4012 2.22387 12.0026 2.62236L3.7383 10.8867C3.33981 11.2852 3.11593 11.8257 3.11593 12.3893C3.11593 12.9529 3.33981 13.4934 3.7383 13.8919L5.73438 15.888ZM12.7539 3.37372C12.8526 3.27505 12.9697 3.19678 13.0986 3.14338C13.2275 3.08999 13.3657 3.0625 13.5052 3.0625C13.6447 3.0625 13.7829 3.08999 13.9118 3.14338C14.0407 3.19678 14.1578 3.27505 14.2565 3.37372L17.2618 6.37892C17.3604 6.47758 17.4387 6.59471 17.4921 6.72361C17.5455 6.85252 17.573 6.99068 17.573 7.13021C17.573 7.26974 17.5455 7.4079 17.4921 7.5368C17.4387 7.66571 17.3604 7.78283 17.2618 7.88149L13.5053 11.638L8.99743 7.13021L12.7539 3.37372ZM19 19.1667C19 19.2364 18.9863 19.3055 18.9596 19.37C18.933 19.4345 18.8938 19.4931 18.8445 19.5424C18.7952 19.5917 18.7366 19.6309 18.6721 19.6576C18.6076 19.6842 18.5385 19.698 18.4688 19.6979H2.53125C2.39035 19.6979 2.25523 19.6419 2.1556 19.5423C2.05597 19.4427 2 19.3076 2 19.1667C2 19.0258 2.05597 18.8906 2.1556 18.791C2.25523 18.6914 2.39035 18.6354 2.53125 18.6354H18.4688C18.5385 18.6354 18.6076 18.6491 18.6721 18.6758C18.7366 18.7025 18.7952 18.7416 18.8445 18.7909C18.8938 18.8403 18.933 18.8988 18.9596 18.9633C18.9863 19.0278 19 19.0969 19 19.1667Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14852_21047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.25 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearNodeIcon);
export default __webpack_public_path__ + "static/media/ClearNodeIcon.4dc0d9d4b1772b4b0b6a7baffb5bf660.svg";
export { ForwardRef as ReactComponent };